module.exports = __webpack_public_path__ + "static/img/character-6.27d03c48.png";